import { Component, OnInit, Input, ComponentFactoryResolver, Injector, ApplicationRef, EmbeddedViewRef } from '@angular/core';
import { HelperService } from '../../services/helper/helper.service';
import { environment } from '../../../environments/environment';
import { ViewVideoModalComponent } from '../view-video-modal/view-video-modal.component';
import { EventService } from '../../services/event/event.service';

@Component({
  selector: 'app-uploaded-file-view',
  templateUrl: './uploaded-file-view.component.html',
  styleUrls: ['./uploaded-file-view.component.css']
})
export class UploadedFileViewComponent implements OnInit {

  @Input() type = 'document';

  public actualData = null;
  private _file = null;
  @Input()
  set file(value) {
    this.actualData = value;
    this._file = {
      ...value,
      extension: value.extension || value.type,
      path: value.path || value.tmp_path
        ? this.helper.getDownloadablePath(value)
        : environment.apiUrl + '/' + value.enc_name
    };
  }

  get file() {
    return this._file;
  }

  get linkUrl() {
    return this._file.url && this._file.url.startsWith('http')
      ? this._file.url
      : 'http://' + this._file.url;
  }

  constructor(
    public helper: HelperService,
    public event: EventService
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/uploaded-file-view/uploaded-file-view.component.ts